export type AvatarCropSourceRect = {
    sx: number
    sy: number
    sw: number
    sh: number
}

export type CropAvatarToBlobOptions = {
    outputWidth: number
    outputHeight: number
    shape: 'circle' | 'square'
    mimeType?: 'image/png' | 'image/jpeg'
    quality?: number
}

export const cropAvatarToBlob = async (
    image: HTMLImageElement,
    crop: AvatarCropSourceRect,
    options: CropAvatarToBlobOptions
): Promise<Blob> => {
    const canvas = document.createElement('canvas')
    canvas.width = Math.max(1, Math.round(options.outputWidth))
    canvas.height = Math.max(1, Math.round(options.outputHeight))
    const ctx = canvas.getContext('2d')
    if (!ctx) {
        throw new Error('Canvas 2D context недоступен')
    }

    ctx.clearRect(0, 0, canvas.width, canvas.height)

    if (options.shape === 'circle') {
        const radius = Math.min(canvas.width, canvas.height) / 2
        ctx.beginPath()
        ctx.arc(canvas.width / 2, canvas.height / 2, radius, 0, Math.PI * 2)
        ctx.closePath()
        ctx.clip()
    }

    ctx.drawImage(image, crop.sx, crop.sy, crop.sw, crop.sh, 0, 0, canvas.width, canvas.height)

    const mimeFromShape = options.shape === 'circle' ? 'image/png' : 'image/jpeg'
    const mime = options.mimeType ?? mimeFromShape
    const quality = mime === 'image/jpeg' ? (options.quality ?? 0.92) : undefined

    return new Promise((resolve, reject) => {
        canvas.toBlob(
            blob => {
                if (blob) {
                    resolve(blob)
                    return
                }
                reject(new Error('canvas.toBlob вернул null'))
            },
            mime,
            quality
        )
    })
}

export const cropAvatarToFile = async (
    image: HTMLImageElement,
    crop: AvatarCropSourceRect,
    options: CropAvatarToBlobOptions,
    filename = 'avatar'
): Promise<File> => {
    const blob = await cropAvatarToBlob(image, crop, options)
    const ext = blob.type === 'image/png' ? 'png' : 'jpg'
    return new File([blob], `${filename}.${ext}`, { type: blob.type })
}
